import { Stack } from 'shared/mui/Stack/Stack';
import { Typography } from 'shared/mui/Typography';

export type DatagridFieldLabelProps = {
  primaryText: string;
  secondaryText: string;
};

export const DatagridFieldLabel = ({
  primaryText,
  secondaryText,
}: DatagridFieldLabelProps): JSX.Element => (
  <Stack>
    <Typography sx={{ fontSize: '14px', fontWeight: 500 }}>{primaryText}</Typography>
    <Typography color="text.disabled" sx={{ fontSize: '14px' }}>
      {secondaryText}
    </Typography>
  </Stack>
);
